export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: 'Coluna Serviços',
              attributes: { class: 'column column-60 p-20 d-flex gap-16 d-sm-column' },
              components: [
               {
                type:'cardServices1',
               },
               {
                type:'cardServices1',
               },
               {
                type:'cardServices1',
               },
              ],
              styles: `
              .p-20{
                padding:20px;
               }
               .column{
                display:flex; 
                flex-direction:column;
                align-items:flex-start;
               }
               .column-60{
                width:60%; 
               }
               .column-40{
                width:40%; 
               }
               .d-flex{
                display:flex; 
                flex-direction:row; 
               }
               .gap-16{
                gap:16px;
               }
               @media (max-width:992px){
                .column-60{
                  width:100%; 
                }
                .column-40{
                  width:100%; 
                }
                .d-sm-column{
                  flex-direction: column !important; 
                }
              }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};